import React from 'react';
import '../components/styles/cheda-gaming-button.css';

type ChedGamingButtonProps = {
  children: React.ReactNode;
  loading?: boolean;
  disabled?: boolean;
  type?: 'button' | 'submit' | 'reset';
  className?: string;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  size?: 'sm' | 'md' | 'lg';
};

const ChedGamingButton: React.FC<ChedGamingButtonProps> = ({
  children,
  loading = false,
  disabled = false,
  type = 'button',
  className = '',
  onClick,
  size = 'md',
}) => {
  return (
    <button
      type={type}
      className={`chedgaming-button ${className} ${size}`.trim()}
      onClick={onClick}
      disabled={disabled || loading}
      aria-busy={loading}
    >
      {loading ? (
        <span className="chedgaming-spinner" aria-hidden="true" />
      ) : (
        children
      )}
    </button>
  );
};

export default ChedGamingButton;
